export function setupSelectedTerms() {
  const filterForm = document.querySelector('.views-exposed-form')

  if (!filterForm) return

  // Locate the <details> element and the associated div
  const detailsElement = filterForm.querySelector('details')
  const durableValueDiv = filterForm.querySelector('.form-item-field-solution-durable-value')

  if (detailsElement && durableValueDiv) {
    // Ensure the div is hidden initially
    durableValueDiv.style.display = detailsElement.hasAttribute('open') ? 'block' : 'none'

    // Add a toggle event listener on the <details> element
    detailsElement.addEventListener('toggle', () => {
      durableValueDiv.style.display = detailsElement.hasAttribute('open') ? 'block' : 'none'
    })
  }

  // Add SVG inside a link appended to the label
  const labelElement = filterForm.querySelector('label[for="edit-field-solution-durable-value"]')
  if (labelElement) {
    // Create the <a> element
    const linkElement = document.createElement('a')
    linkElement.href = '#open-modal-carbon'
    linkElement.className = 'info-icon'
    linkElement.setAttribute('aria-label', 'More information')

    // Define the SVG HTML
    const svgHTML = `
      <svg data-name="Composant 98 – 3" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
        <circle data-name="Ellipse 1854" cx="15" cy="15" r="15" fill="#2c4965"></circle>
        <path data-name="Tracé 7701" d="M1.612 15.044l3.5-.965V26h-3.5zm-.152-4.329a1.549 1.549 0 01.146-.667 1.75 1.75 0 01.4-.546 1.863 1.863 0 01.6-.368A2.014 2.014 0 013.339 9a2.064 2.064 0 01.743.133 1.822 1.822 0 011.009.914 1.534 1.534 0 010 1.333 1.822 1.822 0 01-1.009.914 2.064 2.064 0 01-.743.133A2.014 2.014 0 012.6 12.3a1.863 1.863 0 01-.6-.368 1.75 1.75 0 01-.4-.546 1.549 1.549 0 01-.14-.671z" transform="translate(11.648 -3)" fill="#fff"></path>
      </svg>
    `

    // Set the SVG as the content of the link
    linkElement.innerHTML = svgHTML

    // Append the link to the label
    labelElement.appendChild(linkElement)
  }

  // Create wrapper elements
  const selectedTagsWrapper = document.createElement('div')
  selectedTagsWrapper.className = 'selected-tags-wrapper'
  const selectedCount = document.createElement('span')
  selectedCount.className = 'selected-count'

  // Create the reset button
  const resetButton = document.createElement('button')
  resetButton.type = 'button'
  resetButton.className = 'reset-button'
  // resetButton.textContent = 'Réinitialiser';
  resetButton.style.display = 'none' // Hide initially

  // Append the reset button to the selected-tags-wrapper
  selectedTagsWrapper.appendChild(resetButton)

  // Function to reset the filters
  const resetFilters = () => {
    const checkboxes = filterForm.querySelectorAll('.form-checkbox')
    checkboxes.forEach((checkbox) => {
      checkbox.checked = false
    })
    // Clear selected tags and count
    selectedTagsWrapper.innerHTML = ''
    selectedCount.textContent = ''
    selectedCount.classList.add('empty')
    resetButton.style.display = 'none' // Hide button when no filters are selected
  }

  // Add event listener for the reset button
  resetButton.addEventListener('click', resetFilters)

  // Append wrappers next to the input_wrap inside .form-item-title
  const titleFieldWrapper = filterForm.querySelector('.form-item-title')
  if (titleFieldWrapper) {
    const inputWrap = titleFieldWrapper.querySelector('.input_wrap')
    if (inputWrap) {
      // Insert the selected-tags-wrapper after the input_wrap
      inputWrap.insertAdjacentElement('afterend', selectedTagsWrapper)
    }
  }

  // Append selectCount after the summary
  const summaryElement = filterForm.querySelector('details > summary')
  if (summaryElement) {
    // Append the selectedCount to the <summary> element
    summaryElement.appendChild(selectedCount)
  }

  // Close details element on page load
  if (detailsElement) {
    detailsElement.removeAttribute('open') // Close the details element
  }

  // Function to update selected terms
  const updateSelectedTerms = () => {
    const checkboxes = filterForm.querySelectorAll('.form-checkbox:checked')
    const selectedTerms = Array.from(checkboxes).map((checkbox) => {
      const label = filterForm.querySelector(`label[for='${checkbox.id}']`)
      return label ? label.textContent.trim() : ''
    })

    // Limit the number of tags to 10
    const displayedTerms = selectedTerms.slice(0, 10)
    const remainingTermsCount = selectedTerms.length - 10

    // Update tags
    selectedTagsWrapper.innerHTML = displayedTerms.map((term) => `<span class="term-tag">${term}</span>`).join('')

    // If there are more than 10 terms, append '...'
    if (remainingTermsCount > 0) {
      selectedTagsWrapper.innerHTML += '<span class="term-tag">...</span>'
    }

    // Append the reset button back to the selected-tags-wrapper
    selectedTagsWrapper.appendChild(resetButton)

    // Update count and class
    if (selectedTerms.length > 0) {
      selectedCount.textContent = `${selectedTerms.length}`
      selectedCount.classList.remove('empty')
      resetButton.style.display = 'block' // Show button when filters are selected
    } else {
      selectedCount.textContent = ''
      selectedCount.classList.add('empty')
      resetButton.style.display = 'none' // Hide button when no filters are selected
    }
  }

  // Listen for checkbox changes
  filterForm.addEventListener('change', (event) => {
    if (event.target.type === 'checkbox') {
      updateSelectedTerms()
    }
  })

  // Initialize on load
  updateSelectedTerms()

  function normalizeText(text) {
    return text
      .normalize('NFD') // Normalize accents (é -> e, à -> a)
      .replace(/[\u0300-\u036f]/g, '') // Remove diacritics
      .toLowerCase()
      .replace(/[’']/g, '') // Remove apostrophes (both types of apostrophes)
      .replace(/\s+/g, '-') // Replace spaces with hyphens
  }

  function preCheckFilters() {
    // Vérifier si l'URL contient les termes interdits
    const urlSearchParams = new URLSearchParams(window.location.search)
    if (urlSearchParams.has('title') || urlSearchParams.has('term_node_tid_depth')) {
      return // Ne pas exécuter la fonction si ces termes sont présents
    }

    const urlParts = window.location.pathname.split('/')
    const lastSegment = urlParts[urlParts.length - 1] // Example: "amenagement-urbain"

    // Get all checkboxes inside `.form-checkboxes`
    document.querySelectorAll('.form-checkboxes > ul > li > div > .input_wrap > input[type="checkbox"]').forEach((checkbox) => {
      // Find the closest `.js-form-item` and get the label inside it
      const formItem = checkbox.closest('.js-form-item')
      const label = formItem ? formItem.querySelector('label') : null

      if (label) {
        const rawLabelText = label.textContent.trim() // Use textContent instead of innerText
        const labelText = normalizeText(rawLabelText) // Normalize label text

        if (labelText === lastSegment) {
          checkbox.checked = true // Check the parent checkbox

          // Select child checkboxes if they exist within a nested <ul>
          const parent = formItem.closest('li') // Find the parent <li>
          const childCheckboxes = parent.querySelectorAll('ul > li > div > .input_wrap > input[type="checkbox"]') // Get child checkboxes inside <ul>

          if (childCheckboxes.length > 0) {
            childCheckboxes.forEach((subCheckbox) => {
              subCheckbox.checked = true // Check all sub-checkboxes
            })
          }
        }
      }
    })

    // After checking the checkboxes, update the tags and selected terms
    updateSelectedTerms()
  }

  // Delay execution to wait for dynamic content
  setTimeout(preCheckFilters, 500)
}
